import { useAtomValue } from 'jotai/index';
import * as React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
    BanIcon,
    Button,
    ButtonSize,
    ButtonVariant,
    TrashIcon,
    View,
} from 'smoothie';

import { selectedBillAtom } from '../../state/BillsAtoms';
import { type _Bill, BillActivationStatus } from '../../types/Bill';

interface BillDetailsExcludeButtonProps {
    onPress: () => void;
}

const BillDetailsExcludeButton = ({
    onPress,
}: BillDetailsExcludeButtonProps) => {
    const { bottom } = useSafeAreaInsets();

    const { activationStatus } = useAtomValue(
        selectedBillAtom,
    ) as Partial<_Bill>;

    return (
        <View
            paddingBottom={
                activationStatus === BillActivationStatus.ACTIVE ? 0 : bottom
            }
            paddingTop={8}
        >
            <Button
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.LARGE}
                text="Not a bill"
                onPress={onPress}
                tone={
                    activationStatus === BillActivationStatus.ACTIVE
                        ? 'neutral'
                        : 'danger'
                }
                icon={
                    activationStatus === BillActivationStatus.ACTIVE
                        ? TrashIcon
                        : BanIcon
                }
            />
        </View>
    );
};

export default BillDetailsExcludeButton;
